import React, { useState, useEffect } from 'react';
import {
    Button,
    Grid,
} from '@material-ui/core';
import PageHeader from '../../Components/PageHeader';
import LeftControl from '../../Components/LeftControl';
import Services from '../../Services'
import DynamicTable from '../../Components/TableComponents/DynamicTable';
import { DownloadOutlined } from '@mui/icons-material';
import EDRulebook from '../../assets/pdf/EDRulebook.pdf';
import TransportationRuleBook from '../../assets/pdf/TransportationRuleBook.pdf';
import ExcavationandTrenching from '../../assets/pdf/ExcavationandTrenching.pdf';
import ConfinedSpaceEntry from '../../assets/pdf/ConfinedSpaceEntry.pdf';
import ConfinedSpacePermit from '../../assets/pdf/ConfinedSpacePermit.pdf';
import WorkingNearWater from '../../assets/pdf/WorkingNearWater.pdf';
import CompetentPerson from '../../assets/pdf/CompetentPerson.pdf';
import CompetentPersonDesignation from '../../assets/pdf/CompetentPersonDesignation.pdf';
import FatiguePrevention from '../../assets/pdf/FatiguePrevention.pdf';
import PageLayout from './PageLayout';



const DepartmentInner = (props) => {
    let { apiID, ColumnsData, pageName, safety } = props;

    const [rows, setRows] = useState([])

    const getContacts = async () => {
        let { api } = props
        let data = await api({ id: apiID })
        return (data?.httpStatus == 200) ? data.data : new Error('api failed to fetch contacts')
    }

    useEffect(async () => {
        try {
            let result = await getContacts()
            if (result)
                setRows(result)
        } catch (error) {

        }
    }, [])

    const TableData = {
        header: ColumnsData,
        rows: rows.map(row => [
            row?.name,
            row?.title,
            row?.phone
        ])
    }
    return (
        <PageLayout>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Department</Grid>
                <Grid xs={12} className="ContentPage FormTableArea">
                    {safety ?
                        <Grid xs={12} sm={12} md={12}>
                            <Grid xs={12} container>
                                <Grid xs={6} className="mbold">
                                    {pageName}
                                </Grid>
                            </Grid>
                            <Grid xs={12} className="mt14 ContactTable">
                                <DynamicTable tableData={TableData} />
                            </Grid>
                        </Grid>
                        : <Grid xs={12} sm={12} md={24} lg={24}>
                            <Grid xs={12} container>
                                <Grid xs={6} className="mbold">
                                    {pageName}
                                </Grid>
                            </Grid>
                            <Grid xs={12} lg={24} className="mt14 ContactTable">
                                <DynamicTable tableData={TableData} />
                            </Grid>
                        </Grid>}

                </Grid>
                {/* viewBox="6 -4 14 24" */}
                {safety && <Grid xs={12} sm={12} md={12} >
                    <Grid xs={12} container>
                        <Grid xs={6} className="mbold">
                            Download Rule Book
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={12} md={24} lg={24} className="mt14 ContactTable">
                        <Button >
                            <a href={EDRulebook} className='ButtonLink' target="_blank" download >Engineering Rule Book  <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg> </a>
                        </Button>
                        <Button >
                            <a href={TransportationRuleBook} className='ButtonLink' target="_blank" download >Transportation Rule Book   <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg>  </a>
                        </Button>
                        <Grid xs={12} container>
                            <Grid xs={6} className="mbold" style={{ marginTop: '10px', marginBottom: '10px' }}>
                                Download TGS SOP
                            </Grid>
                        </Grid>
                        <Button >
                            <a href={ExcavationandTrenching} className='ButtonLink' target="_blank" download >Excavation and Trenching <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg>  </a>
                        </Button>
                        <Button >
                            <a href={ExcavationandTrenching} className='ButtonLink' target="_blank" download >Excavation and Trenching  <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg> </a>
                        </Button>
                        <Button >
                            <a href={ConfinedSpaceEntry} className='ButtonLink' target="_blank" download >Confined Space Entry  <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg>  </a>
                        </Button>
                        <Button >
                            <a href={ConfinedSpacePermit} className='ButtonLink' target="_blank" download >Confined Space Permit   <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg>  </a>
                        </Button>
                        <Button >
                            <a href={CompetentPerson} className='ButtonLink' target="_blank" download >Competent Person   <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg>  </a>
                        </Button>
                        <Button >
                            <a href={CompetentPersonDesignation} className='ButtonLink' target="_blank" download >Competent Person Designation <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg>  </a>
                        </Button>
                        <Button >
                            <a href={FatiguePrevention} className='ButtonLink' target="_blank" download >Fatigue Prevention  <svg style={{ height: '25px', width: '30px', marginBottom: '-10px' }}> <DownloadOutlined /> </svg>  </a>
                        </Button>

                    </Grid>
                </Grid>}
            </Grid>
        </PageLayout >
    );

}

export default DepartmentInner